import React, { Component } from 'react';
import Sheet from './sheet';

class SheetContainer extends Component {
    state = {
        examInfo: [
            {id: 1, examNum: '①', text: '증가한다.'},
            {id: 2, examNum: '②', text: '감소한다.'},
            {id: 3, examNum: '③', text: '똑같다.'},
            {id: 4, examNum: '④', text: '증가하다가 감소한다.'},
            {id: 5, examNum: '⑤', text: '알 수 없다.'}
        ]
    };
    render() {
        console.log(this.state.examInfo);
        return (
            <article className="sheet-container scroll-wrapper">
                <h1 className="text-center m-0 p-0">답안 표기란</h1>
                <ul className="sheet-wrap m-0 p-0">
                    <li className="sheet d-flex align-items-center">
                        <div className="icon-wrap d-flex justify-content-center align-items-center">
                            <span className={this.props.examCheckClass === true ? "icon-wrap" : "icon-wrap check-icon-hide"}>
                                <svg className="icon check-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path className="fill" d="M85.286,162.286a.854.854,0,0,1-.606-.251l-3.429-3.429a.857.857,0,0,1,1.212-1.212l2.823,2.823,6.251-6.252a.857.857,0,0,1,1.212,1.212l-6.857,6.858A.857.857,0,0,1,85.286,162.286Z" transform="translate(-75 -146)" fill="#999"/>
                                </svg>
                            </span>
                            
                            <span className={this.props.examMemoClass === true ? "icon-wrap" : "icon-wrap memo-icon-hide"}>
                                <svg className="icon memo-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <g transform="translate(-883.168 -111.484)">
                                        <path className="fill" d="M896.946,124.373h-1.778a.889.889,0,0,1-.889-.889v-1.777a.889.889,0,0,1,.261-.629l5.333-5.333a.889.889,0,0,1,1.257,0l1.778,1.778a.889.889,0,0,1,0,1.257l-5.333,5.333A.888.888,0,0,1,896.946,124.373Zm-.889-1.777h.521l4.445-4.445-.521-.521-4.445,4.445Z" fill="#999"/>
                                        <path className="fill" d="M900.5,131.484H888.057a.889.889,0,0,1-.889-.888V118.151a.889.889,0,0,1,.889-.889h6.222a.889.889,0,1,1,0,1.778h-5.333v10.667h10.667v-5.334a.889.889,0,0,1,1.778,0V130.6A.889.889,0,0,1,900.5,131.484Z" fill="#999"/>
                                    </g>
                                </svg>
                            </span>
                        </div>
                        <button type="button" className="btn exam-bnt">01</button>
                        <form className="sheet-num w-100">
                            <div className="num-wrap d-flex justify-content-center align-items-center">

                                {this.state.examInfo.map(item => (
                                    <Sheet info={item} onSheetSelect={this.props.onSheetSelect} />
                                ))}

                            </div>
                        </form>
                    </li>
                </ul>
            </article>
        );
    }
}

export default SheetContainer;